export default "/_next/static/images/cat-toy 2x-1150eba58fda1f02a4688e266ca26a02.png";